export default {
  Brand: 'CAREQUILT',
  QuickLinkTitle: 'Quick Link',
  QuickLinkItemCareer: 'Careers',
  LegalTitle: 'Legal',
  LegalItemTerms: 'Terms & Conditions',
  LegalItemPrivacy: 'Privacy Policy',
  FollowUsTitle: 'Follow Us',
  FollowUsItemInstagram: 'Instagram',
  FollowUsItemLinkedin: 'Linkedin',
  Copyright: '©#{year} CareQuilt',
};
